import React from 'react';
import { Switch, Route, Redirect } from 'react-router';

import AuthOrApp from './authOrApp'
import Dashboard from '../dashboard/dashboard';
import UsuarioPerfil from '../usuarioPerfil/usuarioPerfil';
import Usuario from '../usuario/usuario';
import Empresa from '../empresa/empresa';
import Fornecedor from '../fornecedor/fornecedor';
import CentroCusto from '../centroCusto/centroCusto';
import FormaPagamento from '../formaPagamento/formaPagamento';
import Grupo from '../grupo/grupo';
import Analitica from '../analitica/analitica';
import Despesa from '../despesa/despesa';
import Receita from '../receita/receita';
import Destinatario from '../destinatario/destinatario';
import Dre from '../dre/dre';

export default props => (
	<div id='id-content-wrapper' className='content-wrapper' >
		<Switch>
			<Route exact path='/' component={Dashboard} />
			<Route path='/usuarioPerfil' component={UsuarioPerfil} />
			<Route path='/usuario' component={Usuario} />
			<Route path='/empresa' component={Empresa} />
			<Route path='/fornecedor' component={Fornecedor} />
			<Route path='/centroCusto' component={CentroCusto} />
			<Route path='/formaPagamento' component={FormaPagamento} />
			<Route path='/grupo' component={Grupo} />
			<Route path='/analitica' component={Analitica} />
			<Route path='/despesa' component={Despesa} />
			<Route path='/receita' component={Receita} />
			<Route path='/destinatario' component={Destinatario} />
			<Route path='/dre' component={Dre} />
			<Redirect from='*' to='/' />
		</Switch>
	</div>
);
